import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Variant } from '@mui/material/styles/createTypography';
import { ArrowRight } from '@phosphor-icons/react';

import {
  ArrowForwardIosTwoToneStyled,
  ListItemButtonStyled,
  ListItemIconStyled,
  ListItemStyled,
  ListItemTextStyled,
} from './ListItemStyled';
import { LabelValuePair } from 'theSource/components/LabelValuePair';
import { isValidHttpsUrl } from 'theSource/utils';

export interface ListItemProps {
  disabled?: boolean;
  isCombined: boolean;
  name: string;
  path?: string;
  handleClick?: () => void;
  title?: string;
  valueHolderVariant?: Variant;
  className?: string;
  selectedLocation?: string;
  planYearContext?: string;
}

export const ListItem = ({
  disabled = false,
  title,
  name,
  path,
  handleClick,
  isCombined,
  valueHolderVariant,
  className,
  selectedLocation,
  planYearContext
}: ListItemProps) => {
  const { t } = useTranslation();

  return (
    <ListItemStyled data-testid="list-item" className={className}>
      <ListItemButtonStyled
        selected={(path ?? '').split('?')[0] === selectedLocation && planYearContext?.split('?')[1] === (path ?? '').split('?')[1]}
        disabled={disabled}
        {...(handleClick
          ? { onClick: () => handleClick(), component: 'a' }
          : { component: path && isValidHttpsUrl(path) ? 'a' : Link, to: path })
        }
        $isCombined={isCombined}
        $smallSpacing={Boolean(title)}
      >
        {title ? (
          <LabelValuePair
            label={t(title)}
            value={t(name)}
            valueHolderVariant={valueHolderVariant}
          />
        ) : (
          <ListItemTextStyled
            data-testid="list-item-text"
            primaryTypographyProps={{
              variant: valueHolderVariant ?? 'body2',
              className: className,
            }}
            primary={t(name)}
          />
        )}
        <ListItemIconStyled>
          {isCombined ? (
            <ArrowForwardIosTwoToneStyled
              weight="bold"
              data-testid="arrow-icon-combined"
            />
          ) : (
            <ArrowRight
              size={24}
              weight="bold"
              data-testid="arrow-icon-separate"
            />
          )}
        </ListItemIconStyled>
      </ListItemButtonStyled>
    </ListItemStyled>
  );
};
